import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

/**
 * Category Service
 * Handles all menu-category related API operations
 */
export const categoryService = {
  // ✅ Get all categories
  getAll: async (branchId) => {
    try {
      const params = {};
      if (branchId) params.branchId = branchId;
      const response = await apiClient.get(ENDPOINTS.MENU_CATEGORY.GET_ALL, { params });
      return response; // already response.data due to interceptor
    } catch (error) {
      console.error('Failed to fetch categories:', error);
      throw error;
    }
  },

  // ✅ Create new category
  create: async (categoryData) => {
    try {
      const response = await apiClient.post(ENDPOINTS.MENU_CATEGORY.CREATE, categoryData);
      return response;
    } catch (error) {
      console.error('Failed to create category:', error);
      throw error;
    }
  },

  // ✅ Update category
  update: async (id, updates) => {
    try {
      const response = await apiClient.put(ENDPOINTS.MENU_CATEGORY.UPDATE(id), updates);
      return response;
    } catch (error) {
      console.error('Failed to update category:', error);
      throw error;
    }
  },

  // ✅ Delete category
  remove: async (id) => {
    try {
      const response = await apiClient.delete(ENDPOINTS.MENU_CATEGORY.DELETE(id));
      return response;
    } catch (error) {
      console.error('Failed to delete category:', error);
      throw error;
    }
  },

  delete(id) {
    return categoryService.remove(id);
  },
};

export default categoryService;
